<template>
  <section id="event-area">
    <div class="sec-title">
      <h2 class="title">
        <!-- <span class="sub"><img src="/images/home/tit_01-sub.png" alt="全国の"></span> -->
        <span class="title-font">オンラインフェスタの<br>配信予定</span>
      </h2>
    </div>
    <div class="container">
      <ul class="tab-menu">
        <li v-for="(value, key) in tabs" :key="key" :class="{'active':key === tab}">
          <span @click.prevent="changeTab(key)">{{value}}</span>
        </li>
      </ul>
      <div class="tab-content-wrap">
        <div class="tab-content active">
          <ul class="area-list">
            <FestaOnlineCard v-for="festa in showFestas" :key="festa.id" :festa=festa :tab=tab />
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FestaOnlineCard from '@/components/molecules/FestaOnlineCard.vue'

export default {
  props: {
    festas: String
  },
  data: () => ({
    festas_json: [],
    planedFesta: [],
    nowDate: new Date(),
    tabs: { all: '配信予定', finished: '実績' },
    tab: 'all',
    finishedFesta: [],
    showFestas: []
  }),
  components: {
    FestaOnlineCard
  },
  methods: {
    festaStatus (festas) {
      const year = this.nowDate.getFullYear()
      const month = this.nowDate.getMonth()
      const day = this.nowDate.getDate()
      const today = new Date(year, month, day, 0, 0, 0)
      festas = festas.slice().sort((a, b) => {
        a = new Date(a.schedules[0].event_date)
        b = new Date(b.schedules[0].event_date)
        return (a === b ? 0 : a > b ? 1 : -1)
      })
      festas.forEach((festa) => {
        const len = Object.keys(festa.schedules).length
        const endD = new Date(festa.schedules[len - 1].event_date.replace(/-/g, '/'))
        if (endD < today) {
          this.finishedFesta.push(festa)
        } else {
          this.planedFesta.push(festa)
        }
      })
      return this.planedFesta
    },
    changeTab (tab) {
      this.tab = tab
      switch (tab) {
        case 'finished':
          this.showFestas = this.finishedFesta
          break
        default:
          this.showFestas = this.planedFesta
      }
    }
  },
  mounted () {
    // this.festas_json = JSON.parse(this.festas)
    this.festas_json = [
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-07-24',
        id: 4,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第4回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '15:30:00',
            event_date: '2020-04-30 00:00:00',
            id: 4,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/3300',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 5,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第5回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-05-09 00:00:00',
            id: 5,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/3376',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-05-14 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 6,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第6回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-05-14 00:00:00',
            id: 6,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/3377',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 7,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第7回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-05-20 00:00:00',
            id: 7,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/3378',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 8,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第8回HakataCCo',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-05-26 00:00:00',
            id: 8,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '16:00:00',
            event_date: '2020-05-27 00:00:00',
            id: 8,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://festa.l-ma.jp/hakatacco2020',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 9,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第9回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:10:00',
            event_date: '2020-06-24 00:00:00',
            id: 9,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '16:10:00',
            event_date: '2020-06-25 00:00:00',
            id: 9,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://festa.l-ma.co.jp/202006',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 10,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第10回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-07-28 00:00:00',
            id: 10,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '16:00:00',
            event_date: '2020-07-29 00:00:00',
            id: 10,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://festa.l-ma.co.jp/202007/',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 11,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第11回',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-08-27 00:00:00',
            id: 11,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '16:00:00',
            event_date: '2020-08-28 00:00:00',
            id: 11,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/5106?params=onfes08',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 12,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第12回オンラインフェスタ',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2020-09-15 00:00:00',
            id: 12,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://bit.ly/31X6vuD',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 13,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'ツルハドラッグ×リトル・ママ×HTB オンラインフェスタ',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '16:00:00',
            event_date: '2021-10-02 00:00:00',
            id: 13,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '16:00:00',
            event_date: '2020-10-03 00:00:00',
            id: 13,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://bit.ly/2Z6Ds5Z',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 14,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'リトル・ママ★ベビー＆キッズハロウィンフェスタ',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '15:00:00',
            event_date: '2020-10-22 00:00:00',
            id: 14,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '15:00:00',
            event_date: '2020-10-24 00:00:00',
            id: 14,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.info/2SvjsWU',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 15,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'オンラインフェスタ～ベビー＆キッズ大運動会～',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '15:00:00',
            event_date: '2020-11-12 00:00:00',
            id: 15,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '15:00:00',
            event_date: '2020-11-14 00:00:00',
            id: 15,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.info/35yiHCL',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2020-06-24',
        id: 16,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'オンラインフェスタ～クリスマスパーティー～',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '15:00:00',
            event_date: '2020-12-17 00:00:00',
            id: 16,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '15:00:00',
            event_date: '2020-12-19 00:00:00',
            id: 16,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.info/3ov7LP8',
        theme: 1,
        updated_at: '2020-04-23 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-01-28',
        id: 17,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'ママと子どもの学び',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:00:00',
            event_date: '2021-01-28 00:00:00',
            id: 17,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.info/37BXLNj',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-02-25',
        id: 18,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'オンライン子育てひろば～新生活の準備～',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-02-25 00:00:00',
            id: 18,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '14:30:00',
            event_date: '2021-02-26 00:00:00',
            id: 18,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/8231',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-03-18',
        id: 19,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'オンライン子育てひろば～知っておきたいお金の話～',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-03-18 00:00:00',
            id: 19,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/8681',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-03-27',
        id: 20,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'ランドセルオンライン合同説明会',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-03-27 00:00:00',
            id: 20,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/7734',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-04-16',
        id: 21,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'コクミンオンラインフェスタ',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-04-16 00:00:00',
            id: 21,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '14:30:00',
            event_date: '2021-04-17 00:00:00',
            id: 21,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/8601',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-04-03',
        id: 22,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'ランドセルオンライン合同説明会',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-04-03 00:00:00',
            id: 22,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/7734',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-05-20',
        id: 23,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: 'HakataCCo',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-05-20 00:00:00',
            id: 23,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '14:30:00',
            event_date: '2021-05-21 00:00:00',
            id: 23,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/9013',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      },
      {
        close_at: '16:00:00',
        created_at: '2020-04-23 19:08:28',
        deleted_at: null,
        event_date: '2021-05-15',
        id: 24,
        information: Object,
        is_online: 1,
        is_release: 0,
        is_showlable_top: 1,
        name: '第一電建フェスタ2021',
        open_at: '10:00:00',
        released_at: null,
        schedulable_id: 69,
        schedules: [
          {
            close_at: '14:30:00',
            event_date: '2021-05-15 00:00:00',
            id: 24,
            is_holiday: false,
            open_at: '10:00:00'
          },
          {
            close_at: '14:30:00',
            event_date: '2021-05-16 00:00:00',
            id: 24,
            is_holiday: false,
            open_at: '10:00:00'
          }
        ],
        site_url: 'https://l-ma.co.jp/events/9216',
        theme: 1,
        updated_at: '2021-01-09 19:09:39',
        uri: 'online20200624'
      }
    ]
    this.festaStatus(this.festas_json)
    this.changeTab('all')
  }
}
</script>

<style lang="sass" scoped>
  .title-font
    position: relative
    z-index: 10
</style>
